export const VIEWS = {
	COACHING: 'COACHING',
	GOT_IT: 'GOT_IT',
	SOLVER: 'SOLVER'
} as const;

export const VIEWS_MAP = {
	COACHING_APPOINTMENTS: 'COACHING_APPOINTMENTS',
	GOT_IT_APPOINTMENTS: 'GOT_IT_APPOINTMENTS',
	COACHING: 'COACHING',
	GOT_IT: 'GOT_IT',
	SOLVER: 'SOLVER'
};

export const ICONS = {
	CALENDAR: 'icons-calendar-date',
	CALL: 'icons-phone',
	USER_X: 'icons-user-cross',
	RETURN: 'icons-undo-left-arrow',
	MESSAGE: 'icons-conversation',
	STAR: 'icons-star',
	QUESTION: 'icons-info-essential',
	TIME: 'icons-alarm',
	CHECK: 'icons-stars',
	ARROW_LEFT: 'icons-alt-arrow-left',
	ARROW_RIGHT: 'icons-alt-arrow-right'
} as const;

export const BUTTON_LABELS = {
	COACHING: 'Koçum Yanımda',
	GOT_IT: 'Şimdi Anladım',
	SOLVER: 'Çözücü'
} as const;

export const STATS_LABELS = {
	SCHEDULED_CALLS: 'Randevulu Görüşme',
	INSTANT_CALLS: 'Anlık Görüşme',
	CALLS_COUNT: 'Görüşme Sayısı',
	NO_PARTICIPATION: 'Katılım Olmayan Görüşme Oranı',
	RETURNED: 'İade Edilen',
	MESSAGES: 'Cevaplanan Mesaj',
	POINT: 'Anlık Ort. Puan',
	POINT_APPOINTMENT: 'Randevulu Ort. Puan',
	RATING: 'Ortalama Puanlama',
	TOTAL_QUESTIONS: 'Toplam Çözülen Soru Sayısı',
	TOTAL_RETURNS: 'Toplam İade Sayısı',
	AVG_TIME: 'Ortalama Süre',
	AVG_SOLUTION_TIME: 'Ortalama Çözüm Süresi',
	TOTAL_PASSED: 'Toplam İncelenen Soru Sayısı'
} as const;

export const TOOLTIP_LABELS = {
	AVG_POINT: 'Ay sonuna kadar puanlanmamış görüşmelerin, aylık ortalama puanın baz alınarak ay sonunda puanlanır',
	CANCELLED: 'İptal Edilen',
	COMPLETED: 'Tamamlanan',
	INSTANT_RATING: 'Anlık Puan',
	SCHEDULED_RATING: 'Randevulu Puan'
} as const;
